<template>
  <div>
    <div class="detail-top">
      <div class="go-back" @click="$router.go(-1)">返回</div>
      <img :src="ossUrl + '/thyroid/bg2.jpg'" />
      <div class="text">
        <span class="name">{{ thyName }}</span>
        <img
          class="wenhao"
          :src="ossUrl + '/wenhao.png'"
          @click="showSignDialog"
        />
        <div>风险等级{{ thyLevel }}级</div>
      </div>
    </div>
    <div class="total-title">
      <img :src="ossUrl + '/thyroid/jiance.png'" />
      器官检测结果
    </div>
    <ThyroidTable :table-data="tableData" />
    <div class="surveys">
      <div class="survey" v-for="item in surveys" :key="item.name">
        <div v-if="item.title != '改善建议'" class="detail-title">
          <img :src="ossUrl + '/thyroid/' + item.name + '.png'" />
          {{ item.title }}
        </div>
        <span v-if="item.title != '改善建议'" class="descs">{{
          item.desc
        }}</span>
      </div>
    </div>
    <!-- 风险等级介绍 -->
    <div v-if="showSign" class="sign-dialog" @click="showSigns">
      <div scroll-y="true" class="signs">
        <img
          class="close"
          :src="ossUrl + '/closed.png'"
          @click="showSignDialog"
        />
        <img :src="ossUrl + '/signs.jpg'" />
      </div>
    </div>
  </div>
</template>
<script>
import { ossUrl } from "@/config";
import ThyroidTable from "@/components/ThyroidTable";
export default {
  name: "Details",
  components: { ThyroidTable },
  data() {
    return {
      ossUrl,
      tableData: [],
      showSign: false,
      surveys: [],
      thyName: "",
      thyLevel: "",
    };
  },
  created() {
    (this.tableData = this.objToArray(
      this.$store.state.thyroidData.organ_list
    ).sort((a, b) => a["order"] - b["order"])),
      (this.surveys = this.objToTextArray(
        this.$store.state.thyroidData.survey
      ).slice(1)),
      (this.thyName = this.$store.state.thyroidData.survey.name),
      (this.thyLevel = this.$store.state.thyroidData.level);
  },
  methods: {
    showSignDialog() {
      this.showSign = !this.showSign;
    },
    /** 特定对象转数组 */
    objToTextArray(obj) {
      let arr = [];
      for (const key in obj) {
        arr.push({
          name: key,
          desc: obj[key].replace(/\\r\\n/g, ""),
          title: this.filterText(key),
        });
      }
      return arr;
    },
    filterText(key) {
      let txt;
      switch (key) {
        case "exam_references":
          txt = "症状";
          break;
        case "exam_desc":
          txt = "发病原因";
          break;
        case "exam_references":
          txt = "并发症";
          break;
        case "experts_science":
          txt = "常规治疗";
          break;
        case "marks_desc":
          txt = "改善建议";
          break;
        case "food_prohibition":
          txt = "饮食禁忌";
          break;
        default:
          break;
      }
      return txt;
    },
    /** 对象转数组 */
    objToArray(obj) {
      let arr = [];
      for (const key in obj) {
        arr.push({
          title: key,
          ...obj[key],
        });
      }
      return arr;
    },
  },
};
</script>
<style lang="scss" scoped>
/* pages/thyroidDetail/thyroidDetail.wxss */
.detail-top {
  position: relative;
  width: 100%;
  height: auto;
  margin-bottom: 60px;
}
.detail-top>img {
  width: 100%;
  border-bottom: 20px solid rgb(231, 239, 243);
}
.detail-top img.wenhao {
  width: 50px;
  height: 50px;
  border-bottom: none;
  margin-right: 20px;
}
.text {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 40px;
  margin: auto;
  height: 80px;
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.5);
  color: #333;
}
.text .name {
  font-size: 36px;
  padding: 0 15px 0 30px;
}
.text div {
  color: rgb(240, 6, 6);
  font-size: 36px;
}
.total-title {
  font-size: 28px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  height: 50px;
  padding-left: 25px;
}
.detail-title {
  font-size: 28px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  height: 50px;
}
.detail-title img,
.total-title img {
  height: 40px;
  margin-right: 25px;
}
.surveys {
  width: 700px;
  margin: 60px auto 40px;
}
.survey {
  margin-bottom: 35px;
}
.survey .descs {
  font-size: 24px;
  color: #666;
  text-align: left;
  line-height: 48px;
  display: block;
}
.sign-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1999;
}
.sign-dialog .signs {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 700px;
  height: 900px;
  overflow-y: auto;
  padding: 30px 0 10px;
  margin: auto;
  background-color: #fff;
  z-index: 9999;
}
.sign-dialog .signs .close {
  float: right;
  width: 40px;
  height: 40px;
  margin-right: 25px;
  margin-bottom: 25px;
}
.sign-dialog .signs img {
  width: 100%;
}
.go-back{
  position: absolute;
  top: 20px;
  left: 20px;
  width: 100px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background-color: #fff;
  font-size: 32px;
  border-radius: 5px;
  color: #409eff;
  font-weight: bold;
}
</style>